/**
 * Catálogo de coberturas (basado en pantallazos del ERP de referencia).
 * Lista plana — el modal puede filtrarla en el futuro por aseguradora.
 */
export const COBERTURAS = [
  "Sin Cobertura",
  "Actos vandálicos",
  "Alimentos refrigerados",
  "Avería maquinaria",
  "Caída de rayo",
  "Cristales, mármoles, vitrocerámicas y loza sanitaria",
  "Daños eléctricos",
  "Daños por agua",
  "Daños por impacto",
  "Explosión",
  "Fenómenos atmosféricos",
  "Humo",
  "Incendio",
  "Inhabitabilidad o pérdida de alquileres",
  "Inundación y daños por líquidos",
  "Paralización de actividad/pérdida de beneficios",
  "Reclamación de daños",
  "Reposición estética",
  "Responsabilidad Civil",
  "Robo, atraco, infidelidad de empleados y hurto",
  "Transportes",
];

export const TIPO_LABEL = {
  asegurado: "Asegurado",
  perjudicado: "Perjudicado",
  causante: "Causante",
};

export const TIPO_HINT = {
  asegurado: "Daños propios al asegurado y reparación del origen.",
  perjudicado: "Daños a terceros derivados del siniestro.",
  causante: "Valoración estimativa de la obligación de hacer.",
};

export const fmtEUR = (v) => {
  if (v === null || v === undefined || v === "") return "—";
  const n = Number(v);
  if (Number.isNaN(n)) return "—";
  return n.toLocaleString("es-ES", { style: "currency", currency: "EUR" });
};

/** Total de una partida (mantener idéntico a backend services/valoracion.py). */
export function calcularPartida(p) {
  const cant = Number(p?.cantidad || 0);
  const pu = Number(p?.precio_unitario || 0);
  let bruto = cant * pu;
  const dep = Number(p?.depreciacion_pct || 0);
  if (dep) bruto *= Math.max(0, 1 - dep / 100);
  const iva = Number(p?.iva_pct || 0);
  if (iva) bruto *= 1 + iva / 100;
  return Math.round(bruto * 100) / 100;
}

/** Subtotal de un grupo aplicando límite y franquicia. */
export function calcularSubtotalGrupo(g) {
  if (!g || g.excluir) return 0;
  let s = (g.partidas || []).reduce((acc, p) => acc + calcularPartida(p), 0);
  if (g.limite !== null && g.limite !== undefined && g.limite >= 0) {
    s = Math.min(s, Number(g.limite));
  }
  const franq = Number(g.franquicia || 0);
  if (franq) {
    if (g.franquicia_tipo === "pct") s *= Math.max(0, 1 - franq / 100);
    else s = Math.max(0, s - franq);
  }
  return Math.round(s * 100) / 100;
}
